import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { nfRp } from '@/constants/nf';
import { route } from '@/constants/routeName';
import {
	EMPTY_CART_ITEMS,
	cartMealDateCount,
	cartOwnerIds,
	cartQuantityTotal,
	unpaidTotalForLines,
} from '@/helper/cartFamily';

/**
 * Family cart CTA at the end of page content (not fixed/sticky).
 */
export default function StickyReviewCartPay() {
	const navigate = useNavigate();
	const cartItems = useSelector((state) => state.cart.items) ?? EMPTY_CART_ITEMS;
	const cartQty = cartQuantityTotal(cartItems);
	const unpaidTotal = unpaidTotalForLines(cartItems);
	const owners = cartOwnerIds(cartItems);
	const mealDates = cartMealDateCount(cartItems);

	if (cartQty <= 0) return null;

	return (
		<section className='family-cart-banner' aria-label='Family cart summary'>
			<div className='row'>
				<strong>
					{cartQty} item{cartQty === 1 ? '' : 's'} saved in cart
				</strong>
				<strong>{nfRp(unpaidTotal)}</strong>
			</div>
			<small className='muted'>
				{mealDates} meal date{mealDates === 1 ? '' : 's'} · {owners.length} child
				{owners.length === 1 ? '' : 'ren'} · Not paid
			</small>
			<button type='button' className='main' onClick={() => navigate(`/${route.cart}`)}>
				Review cart & pay
			</button>
		</section>
	);
}
